// 課題126: 特別オファー / 招待状の文面テンプレート（固定プリセット）。
// {{name}} は送信時にバックエンドが宛先クルー名（User.name）へ置換する。
// フロントのプレビューでは crewName に置換して表示する。
import type { SpecialOfferType } from '../types';

export const NAME_PLACEHOLDER = '{{name}}';

export interface SpecialOfferTemplate {
  id: string;
  offer_type: SpecialOfferType;
  label: string;
  title: string;
  message: string;
  reward: string;
}

export const SPECIAL_OFFER_TEMPLATES: SpecialOfferTemplate[] = [
  {
    id: 'special_wage_up',
    offer_type: 'special',
    label: '特別時給アップ',
    title: '{{name}}さんへ特別時給のご案内',
    message:
      '{{name}}さん、いつもありがとうございます。\n' +
      '{{name}}さんの働きぶりを見込んで、特別時給でのシフトをご案内します。ぜひご検討ください。',
    reward: '時給+200円',
  },
  {
    id: 'special_thanks',
    offer_type: 'special',
    label: '感謝＋次シフトのお願い',
    title: '{{name}}さんへお礼とお願い',
    message:
      '{{name}}さん、先日はお疲れさまでした。\n' +
      'またぜひ一緒に働いていただきたく、次回のシフトをご案内します。',
    reward: '',
  },
  {
    id: 'invitation_comeback',
    offer_type: 'invitation',
    label: '復帰のお誘い',
    title: '{{name}}さんへ復帰のお誘い',
    message:
      '{{name}}さん、お久しぶりです。\n' +
      'よろしければまた一緒に働きませんか。{{name}}さんのご都合に合わせてご相談させてください。',
    reward: '',
  },
  {
    id: 'invitation_career',
    offer_type: 'invitation',
    label: 'キャリア面談の案内',
    title: '{{name}}さんへキャリア面談のご案内',
    message:
      '{{name}}さん、いつもありがとうございます。\n' +
      '今後のキャリアについて一度お話しさせていただけませんか。',
    reward: '',
  },
];

/** {{name}} を実際の名前へ置換する（プレビュー表示用。空名ならプレースホルダを除去）。 */
export function fillRecipientName(text: string, name: string): string {
  return text.split(NAME_PLACEHOLDER).join(name || '');
}
